export function ficDeMenu() {
    // console.log("boom");

    try {
        var x = document.getElementById("fic--ident-topNav");

        if (x.style.display === "block") {
            x.style.display = "none";
        }
    } catch (e) {

    }
    //  else {
    //     x.style.display = "block";
    // }
}